module.exports = __webpack_public_path__ + "ab0d023c48168f98d9fdcac1cc3315bf.pdf";